export const environment = {
  production: true,
  apiUrl: 'https://api.transtur.net/v1/',
  imageUrl: 'https://api.transtur.net/v1/',
  defaultLanguage: 'es',
  defaultCurrency: 'CUP',
  version: '0.1.1',
  defaultMarket: {
    lat: 23.131268,
    lng: -82.3582717,
  },
};
